import script from "./ModalFlashMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalFlashMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ModalFlashMessage.vue?vue&type=style&index=0&id=4021d5e8&lang=css"

const __exports__ = script;

export default __exports__